import { Field } from "kts-scaffold-framework/utils/doc";

/**
 * 数字金额转换为大写金额
 * @param {number} amount 金额
 * @return {string} 大写格式金额
 */
var toAmountChinese = function(amount:number):string {
    if(amount < 0){
        return `负${Field.toStringChinese(Math.abs(amount))}`;
    }
    return Field.toStringChinese(amount);
};

export default {
    toAmountChinese
};


// WEBPACK FOOTER //
// ./src/utils/Doc/Amount.ts